<template>
  <div class="dialog-wrap">
    <el-dialog
      :visible="visible"
      title="公告预览"
      class="dialog"
      width="800px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <div class="card no-padding no-margin">
        <div class="section">
          <div class="section-content flex-column flex-center">
            <div v-if="title" class="title">{{ title }}</div>
            <div style="width: 100%;">
              <u-editor :value="content" disabled />
            </div>
          </div>
        </div>
      </div>
      <span v-if="operationVisible" slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UEditor from '@/components/common/UEditor/index.vue'

export default {
  components: {
    UEditor
  },

  props: {
    compileApi: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      visible: false,

      operationVisible: false, // 是否显示操作按钮

      title: '',
      content: '',

      orderId: '',
      noticeType: '',
      noticeTemp: '',
      customData: null
    }
  },

  watch: {
    compileApi: function(val) {
      if (val) {
        this.getCompileNotice()
      }
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    open(data) {
      this.visible = true
      this.title = data.title
      this.orderId = data.orderId
      this.noticeType = data.noticeType
      this.noticeTemp = data.noticeTemp
      this.customData = data.customData || null
      this.getCompileNotice()
    },

    /**
     * 获取编译后
     */
    async getCompileNotice() {
      try {
        const _data = await this.compileApi(
          {
            noticeType: this.noticeType,
            noticeTemp: this.noticeTemp,
            customData: this.customData
          },
          this.orderId
        )
        this.content = _data.data?.noticeContent || ''
        this.operationVisible = true
      } catch (error) {
        this.operationVisible = false
        this.$message.error(error.message)
      }
    },

    /**
     * 关闭弹窗
     */
    handleDialogClose() {
      this.content = ''
      this.visible = false
    },

    /**
     * 确认提交
     */
    submit() {
      this.$emit('publish', this.content)
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  color: $text-color;
  font-size: 16px;
  @include text-bold;
  text-align: center;
  margin-bottom: 16px;
}
</style>
